<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GEn0Bv/tc-custom/9780226039039.jpg?1722573925283" alt="This image is the cover for the book Image of God"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Image of God
      </h1>
      <p class="bookDescription body article font2">
        <p>During the first half of the twentieth century, supporters of the eugenics movement offered an image of a racially transformed America by curtailing the reproduction of “unfit” members of society. Through institutionalization, compulsory sterilization, the restriction of immigration and marriages, and other methods, eugenicists promised to improve the population—a policy agenda that was embraced by many leading intellectuals and public figures. But Catholic activists and thinkers across the United States opposed many of these measures, asserting that “every man, even a lunatic, is an image of God, not a mere animal."<br/>In <i>An Image of God</i>, Sharon Leon examines the efforts of American Catholics to thwart eugenic policies, illuminating the ways in which Catholic thought transformed the public conversation about individual rights, the role of the state, and the intersections of race, community, and family. Through an examination of the broader questions raised in this debate, Leon casts new light on major issues that remain central in American political life today: the institution of marriage, the role of government, and the separation of church and state. This is essential reading in the history of religion, science, politics, and human rights.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon M. Leon
      </h2>
      
      <p class="authorDescription body article"><B>Sharon M. Leon</B> is director of public projects at the Roy Rosenzweig Center for History and New Media and research associate professor of history at George Mason University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?30303ba7